import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {NzConfigService} from 'ng-zorro-antd/core/config';

@Component({
  selector: 'ptc-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private nzConfigService: NzConfigService) {
    // This is default theme
    this.nzConfigService.set('theme', {primaryColor: '#E87A00'});
  }
}
